import { browserHistory } from 'react-router';

export default function goToFeatureListingPage(organizationId: string) {
  return browserHistory.push(`/${organizationId}/organization/features`);
}
